import React from 'react';
import PendidikanIcon from '../CategoryImages/feature_2.png'
import '../CategoryBanner/categorybanner.css'

const BannerPendidikan = () => {
    return (
        <div className="banner-category">
            <div className="banner-category-row">
                <img src={PendidikanIcon} alt="" width="100" />
                <div className="banner-category-column">
                    <h5 className="banner-name">Pendidikan</h5>
                    <p className="banner-name-txt">Donasi Terbuka</p>
                </div>
            </div>
        </div>
    )
}

export default BannerPendidikan;